var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoccerField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 698,
    viewBox: "0 0 1152 698",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_5823_63949)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M-124.814 724.875H-264.765L-30.3216 -35.2688H70.4278L-124.814 724.875Z",
    fill: "url(#paint0_linear_5823_63949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M154.96 724.875H15.137L171.305 -35.2688H272.182L154.96 724.875Z",
    fill: "url(#paint1_linear_5823_63949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M434.863 724.875H294.912L373.06 -35.2688H473.809L434.863 724.875Z",
    fill: "url(#paint2_linear_5823_63949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M714.635 724.875H574.684V-35.2688H675.561L714.635 724.875Z",
    fill: "url(#paint3_linear_5823_63949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M994.411 724.875H854.588L776.44 -35.2688H877.317L994.411 724.875Z",
    fill: "url(#paint4_linear_5823_63949)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1274.31 724.875H1134.36L978.067 -35.2688H1078.94L1274.31 724.875Z",
    fill: "url(#paint5_linear_5823_63949)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.477 553.812H-134.157L-133.007 549.68L-0.673767 66.2944H232.156L151.477 553.812ZM-125.719 547.355H145.979L224.612 73.0099H4.1848L-125.719 547.355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53818 398.37H-92.6357L-91.4865 394.289L-31.5988 178.234H56.7644L4.53818 398.37ZM-83.825 391.993H-0.569534L49.1028 184.484H-26.3634L-83.825 391.993Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M583.112 283.582C582.602 285.406 581.509 287.014 579.999 288.159C578.488 289.305 576.644 289.925 574.748 289.925C572.852 289.925 571.007 289.305 569.497 288.159C567.987 287.014 566.893 285.406 566.384 283.582C566.67 281.651 567.695 279.907 569.243 278.717C570.792 277.528 572.743 276.985 574.684 277.205C579.281 276.822 583.112 279.628 583.112 283.582Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.079 283.583C118.332 285.527 116.994 287.187 115.254 288.331C113.513 289.475 111.456 290.045 109.374 289.96C104.777 289.96 101.585 287.027 102.351 283.583C103.04 281.627 104.346 279.948 106.073 278.797C107.801 277.647 109.855 277.089 111.928 277.206C116.525 276.824 119.717 279.63 119.079 283.583Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M574.686 398.37C553.291 399.023 531.985 395.336 512.057 387.532C492.128 379.728 473.991 367.969 458.741 352.966C449.721 343.869 442.674 333.013 438.038 321.076C433.403 309.139 431.279 296.376 431.798 283.584C435.373 224.915 498.198 179 574.686 179C651.174 179 713.998 224.915 717.702 283.584C718.257 296.419 716.15 309.23 711.513 321.213C706.877 333.197 699.811 344.094 690.758 353.221C675.463 368.182 657.294 379.895 637.346 387.654C617.397 395.414 596.083 399.059 574.686 398.37ZM574.686 185.122C501.518 185.122 441.63 228.358 438.183 283.711C437.669 295.713 439.676 307.689 444.075 318.869C448.473 330.05 455.165 340.187 463.721 348.629C494.078 376.522 533.821 392.003 575.069 392.003C616.317 392.003 656.06 376.522 686.417 348.629C694.979 340.171 701.666 330.009 706.043 318.804C710.421 307.598 712.392 295.599 711.828 283.584C707.869 227.976 647.981 184.739 574.686 184.739V185.122Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.475 378.345L204.122 195.196L208.08 197.492C223.541 205.493 236.174 218.035 244.28 233.428C252.385 248.82 255.572 266.325 253.411 283.582C248.431 319.294 220.594 353.602 179.094 375.284L173.475 378.345ZM208.846 205.527L181.903 366.484C218.423 345.695 242.557 314.702 247.154 282.689C249.26 267.473 246.732 251.976 239.9 238.214C233.068 224.452 222.247 213.063 208.846 205.527Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M577.878 669.139H-167.207L-166.058 665.058L19.9901 -6.57251H577.878V669.139ZM-158.779 662.762H571.366V-0.450545H24.8424L-158.779 662.762Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4367 17.6603H13.2229L19.9906 -6.57251H53.1905L52.169 -2.61874C49.1281 3.88569 44.1754 9.31049 37.9706 12.9333C31.7658 16.5561 24.6032 18.2049 17.4367 17.6603ZM24.8429 -0.195466L22.289 11.0281C30.9669 10.3857 39.0416 6.35309 44.7629 -0.195466H24.8429Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.12 548.231H997.987V545.552L917.413 66.7639H1149.94L1283.12 548.231ZM1003.35 541.854H1274.82L1145.09 73.396H924.947L1003.35 541.854Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.62 398.37H1144.96L1092.22 178.234H1180.71L1241.62 398.37ZM1150.07 391.993H1233.32L1175.86 184.611H1100.4L1150.07 391.993Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.06 283.583C1031.77 285.55 1033.1 287.233 1034.85 288.382C1036.6 289.532 1038.67 290.085 1040.76 289.96C1045.36 289.96 1048.55 287.027 1047.79 283.583C1047.07 281.617 1045.74 279.934 1044 278.784C1042.25 277.635 1040.17 277.081 1038.08 277.206C1032.85 276.824 1029.65 279.63 1031.06 283.583Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M976.024 378.345L970.278 375.284C928.905 353.602 901.068 319.294 895.961 283.582C893.871 266.287 897.131 248.768 905.303 233.378C913.475 217.988 926.167 205.465 941.675 197.492L945.761 195.196L976.024 378.345ZM940.525 205.527C927.184 213.128 916.413 224.529 909.59 238.273C902.767 252.017 900.2 267.481 902.218 282.689C906.687 314.702 930.948 345.695 967.469 366.484L940.525 205.527Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.71 669.14H571.365V-6.82715H1129.38L1316.71 669.14ZM577.878 662.763H1308.28L1124.66 -0.450104H577.878V662.763Z",
    fill: "url(#paint6_linear_5823_63949)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.28 17.6603H1132.06C1124.89 18.2232 1117.72 16.5821 1111.52 12.9572C1105.31 9.33225 1100.36 3.89709 1097.33 -2.61874L1096.31 -6.57251H1129.51L1136.28 17.6603ZM1105.38 -0.195464C1108.2 3.05812 1111.64 5.72397 1115.49 7.64977C1119.35 9.57556 1123.55 10.7236 1127.85 11.0281L1124.66 -0.195464H1105.38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5823_63949",
    x1: -97.1047,
    y1: 724.875,
    x2: -97.1047,
    y2: -35.2688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5823_63949",
    x1: 11710.7,
    y1: 192220,
    x2: 11710.7,
    y2: 146916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5823_63949",
    x1: 11808.7,
    y1: 192220,
    x2: 11808.7,
    y2: 146916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5823_63949",
    x1: 12434.1,
    y1: 192220,
    x2: 12434.1,
    y2: 146916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5823_63949",
    x1: 23358.3,
    y1: 192220,
    x2: 23358.3,
    y2: 146916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5823_63949",
    x1: 37253.4,
    y1: 192220,
    x2: 37253.4,
    y2: 146916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5823_63949",
    x1: 584.694,
    y1: 678.751,
    x2: 874.768,
    y2: -7.23306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5823_63949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 698,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerField);
export default __webpack_public_path__ + "static/media/soccer-field.218256362442f52f8d788f272dd46f01.svg";
export { ForwardRef as ReactComponent };